export default __webpack_public_path__ + "static/media/image-need-help-page.a3858494.png";